import service from './axios';

// ==================== Banner ====================
export const getBanners = (params = {}) => service.get('/manage/banners', { params });
export const getBanner = (id) => service.get(`/manage/banners/${id}`);
export const createBanner = (data) => service.post('/manage/banners', data);
export const updateBanner = (id, data) => service.put(`/manage/banners/${id}`, data);
export const deleteBanner = (id) => service.delete(`/manage/banners/${id}`);

// ==================== Working Dog ====================
export const getWorkingDogs = (params = {}) => service.get('/manage/working-dogs', { params });
export const getWorkingDog = (id) => service.get(`/manage/working-dogs/${id}`);
export const createWorkingDog = (data) => service.post('/manage/working-dogs', data);
export const updateWorkingDog = (id, data) => service.put(`/manage/working-dogs/${id}`, data);
export const deleteWorkingDog = (id) => service.delete(`/manage/working-dogs/${id}`);

// ==================== Company Info ====================
export const getCompanyInfos = () => service.get('/manage/company-infos');
export const updateCompanyInfos = (data) => service.put('/manage/company-infos', data);

// ==================== Home Icons ====================
export const getHomeIcons = () => service.get('/manage/home-icons');
export const createHomeIcon = (data) => service.post('/manage/home-icons', data);
export const updateHomeIcon = (id, data) => service.put(`/manage/home-icons/${id}`, data);
export const deleteHomeIcon = (id) => service.delete(`/manage/home-icons/${id}`);

// ==================== Content Pages ====================
export const getContentPages = () => service.get('/manage/content-pages');
export const getContentPage = (type) => service.get(`/manage/content-pages/${type}`);
export const updateContentPage = (type, data) => service.put(`/manage/content-pages/${type}`, data);

// ==================== Search Hotwords ====================
export const getSearchHotwords = (params = {}) => service.get('/manage/search-hotwords', { params });
export const createSearchHotword = (data) => service.post('/manage/search-hotwords', data);
export const updateSearchHotword = (id, data) => service.put(`/manage/search-hotwords/${id}`, data);
export const deleteSearchHotword = (id) => service.delete(`/manage/search-hotwords/${id}`);

// ==================== TabBar Config ====================
export const getTabBarConfigs = () => service.get("/manage/tab-bar-configs");
export const updateTabBarConfig = (id, data) => service.put(`/manage/tab-bar-configs/${id}`, data);

// ==================== Pet Selectors ====================
export const getPetSelectors = () => service.get('/manage/pet-selectors');
export const updatePetSelector = (id, data) => service.put(`/manage/pet-selectors/${id}`, data);

// ==================== Custom Pages ====================
export const getCustomPages = () => service.get('/manage/custom-pages');
export const createCustomPage = (data) => service.post('/manage/custom-pages', data);
export const updateCustomPage = (id, data) => service.put(`/manage/custom-pages/${id}`, data);
export const deleteCustomPage = (id) => service.delete(`/manage/custom-pages/${id}`);
